<p-carousel
  [value]="getFilteredPlans(subscriptionInterval())"
  [showIndicators]="false"
  [circular]="false"
  [responsiveOptions]="responsiveOptions"
>
  <ng-template #header>
    <div class="tw-mb-2 tw-flex">
      @if (headerTemplate()) {
        <ng-container *ngTemplateOutlet="headerTemplate()"></ng-container>
      }
      <p-selectbutton
        class="tw-ml-auto"
        [allowEmpty]="false"
        [(ngModel)]="subscriptionInterval"
        [options]="subscriptionIntervalOptions"
        size="small"
      >
        <ng-template #item let-item>
          @if (isPlanInCurrentInterval(item.value)) {
            <p-overlaybadge> {{ item.label }}</p-overlaybadge>
          }
          @if (!isPlanInCurrentInterval(item.value)) {
            {{ item.label }}
          }
        </ng-template>
      </p-selectbutton>
    </div>
  </ng-template>
  <ng-template let-plan #item>
    <p-panel styleClass="tw-mx-2 tw-text-center tw-border-black">
      <ng-template #header>
        <div class="tw-text-lg tw-w-full">
          {{ plan.attributes.title }}
        </div>
      </ng-template>
      <div class="tw-flex tw-justify-center tw-gap-1.5">
        <span class="tw-text-lg tw-font-bold">
          {{ plan.attributes.price_exc_tax | number: '1.0-0' }} {{ plan.attributes.currency_code }}
        </span>
        <small class="tw-flex tw-items-end">/{{ subscriptionInterval() === 'year' ? 'år' : 'måned' }}</small>
      </div>

      <div>{{ plan.attributes.invoice_limit | number: '1.0-0' }} ordre</div>

      <div class="tw-text-xs tw-min-h-4">
        @if (subscriptionInterval() === 'year') {
          ({{ plan.attributes.price_exc_tax / 12 | number: '1.0-0' }} {{ plan.attributes.currency_code }} /måned)
        }
      </div>
      <ng-template #footer>
        <div class="tw-flex tw-flex-col">
          @if (plan.id !== selectedPlanId() && plan.id !== currentPlanId()) {
            <p-button class="tw-w-full" fluid size="small" (onClick)="onSelectPlan(+plan.id)"> Vælg plan </p-button>
          }

          @if (plan.id === selectedPlanId() && plan.id !== currentPlanId()) {
            <fa-icon
              [icon]="['fal', 'check-circle']"
              [size]="'2xl'"
              [fixedWidth]="true"
              class="tw-text-success-600 tw-my-0.5"
            />
          }
          @if (plan.id === currentPlanId()) {
            <span class="tw-font-bold tw-my-1.5" data-testid="current-plan-label">Nuværende abonnement</span>
          }
        </div>
      </ng-template>
    </p-panel>
  </ng-template>
  <ng-template #footer>
    <ng-content />
  </ng-template>
</p-carousel>
